export default from './NewMessageField';



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/NewMessageField/index.js